// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeValidity {
  Days10 = "DAYS10",
  Days30 = "DAYS30",
  Annual = "ANNUAL",
  SingleDay = "SINGLE_DAY",
}

/**
 * Return number of days for given charge type. It is used to sort charge types in ascending/descending order and calculate approximate valid until.
 * @param validFor
 */
export const validityDays = (validFor: ChargeValidity): number => {
  switch (validFor) {
    case ChargeValidity.Days10:
      return 10;
    case ChargeValidity.Days30:
      return 30;
    case ChargeValidity.Annual:
      return 365;
    case ChargeValidity.SingleDay:
      return 1;
  }
};

/**
 * Return price for charge type.
 * @param validFor
 */
export const mockChargePrice = (validFor: ChargeValidity): number => {
  switch (validFor) {
    case ChargeValidity.Days10:
      return 270;
    case ChargeValidity.Days30:
      return 430;
    case ChargeValidity.Annual:
      return 2300;
    case ChargeValidity.SingleDay:
      return 200;
  }
};

/**
 * Takes number of days from URL prefilled order and selects appropriate charge type
 * @param days
 */
export const daysValidFor = (days: number) => {
  if (days <= 1) return ChargeValidity.SingleDay;
  if (days <= 10) return ChargeValidity.Days10;
  if (days <= 30) return ChargeValidity.Days30;
  return ChargeValidity.Annual;
};

export default ChargeValidity;
